import React from 'react';
import { useSelector } from 'react-redux';
import 'react-select-v1/dist/react-select.css';
import { CaseStatus, } from '@debbie/common/dist/cases';
import { Panel } from '..';
import UserPreview from '../performed-by/UserPreview';
import HistItem from './HistItem';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons';
import { h } from '@debbie/cortex/dist';
import { objectBy } from '@debbie/common/dist/util';
const CaseStatusItem = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const endReasons = useEndReasons();
    const endReasonLookup = h.hasData(endReasons)
        ? objectBy(endReasons.data, (er) => er.id)
        : {};
    if (!props.date)
        return null;
    if (props.data.status === CaseStatus.PENDING)
        return null;
    const endReason = props.data.endReasonId
        ? endReasonLookup[props.data.endReasonId]
        : null;
    return (React.createElement(HistItem, { date: props.date, timespan: props.timespan, heading: React.createElement("span", null,
            props.data.createdByUserId && (React.createElement(UserPreview, { id: props.data.createdByUserId })),
            props.data.status === CaseStatus.VERIFIED
                ? lang.cases.case + ' ' + lang.cases.VERIFIED
                : lang.cases.case + ' ' + lang.cases.ENDED) }, endReason && (React.createElement(Panel, null, (_a = lang.endReason[endReason.handle]) !== null && _a !== void 0 ? _a : endReason.label))));
};
export default CaseStatusItem;
//# sourceMappingURL=CaseStatusItem.js.map